<autocomplete-selector
  [config]="selectorConfig"
  [selected]="selected"
  (selectedChange)="update($event)"
></autocomplete-selector>
